import { AddExperimentsResult } from 'utility/types/dataProvider';
import { httpClient } from 'providers/clients/httpClient';
import { paths } from 'utility/types/openapi-ts-generated';

export type GetExperimentByNameParams =
  paths['/core/experiment/{name}/']['get']['parameters']['path'];

export type GetExperimentByNameResult =
  paths['/core/experiment/{name}/']['get']['responses'][200]['content']['application/json'];

// -----------------------------------------------
// ------------ EXPERIMENTS PROVIDER -------------
// -----------------------------------------------
export const experimentsProvider = {
  updateExperiment: async (name: string, enabled: boolean): Promise<any> => {
    try {
      const params = {
        enabled: enabled,
      };

      const path = `/core/experiment/${name}/`;

      const response = await httpClient({
        url: path,
        method: 'PUT',
        data: JSON.stringify(params),
      });

      return response;
    } catch (error) {
      console.error('[updateExperiment] Error:', error);
      throw error;
    }
  },

  addExperiment: async (name: string): Promise<any> => {
    try {
      const params = {
        name: name,
      };
      const path = `/core/experiment/`;

      const { data } = await httpClient({
        url: path,
        method: 'POST',
        data: JSON.stringify(params),
      });

      // Key-value pair using the id as the key
      const result: AddExperimentsResult = { ...data.data };
      return result;
    } catch (error) {
      console.error('[addExperiment] Error:', error);
      throw error;
    }
  },

  deleteExperiment: async (name: string): Promise<any> => {
    try {
      const path = `/core/experiment/${name}/`;

      const response = await httpClient({
        url: path,
        method: 'DELETE',
      });

      return response;
    } catch (error) {
      console.error('[deleteExperiment] Error:', error);
      throw error;
    }
  },

  // Fetch a single experiment by its name
  // GET /core/experiment/{name}/
  getExperimentByName: async (
    params: GetExperimentByNameParams,
  ): Promise<GetExperimentByNameResult> => {
    try {
      const expName = params?.name;

      if (!expName) {
        throw new Error('[getExperimentByName] Missing required parameters.');
      }

      const url = `/core/experiment/${expName}/`;

      const { data } = await httpClient<GetExperimentByNameResult>({
        url: url,
        method: 'GET',
      });

      const result: GetExperimentByNameResult = {
        status: data?.status,
        data: data?.data,
      };

      return result;
    } catch (error) {
      console.error('[getExperimentByName] Error:', error);
      throw error;
    }
  },
};
